import { t } from 'i18next'

import { Contract, ContractTenant } from '../../../../../common/validations'
import {
  ContractChangesSection,
  TerminationDisallowedReason,
} from '../../../../../common/types'
import { hasActiveTermination } from '../../utils/hasActiveTermination'
import { isAdultTenant } from '../../utils/isAdultTenant'

export const resolvePendingContractChangesNotice = (
  contract: Contract,
  tenants: ContractTenant[],
  otherSection: ContractChangesSection
) => {
  const reason = contract.terminationDisallowedReason

  if (
    !hasActiveTermination(contract, tenants) ||
    reason === TerminationDisallowedReason.CONTRACT_TERMINATED
  ) {
    return undefined
  }

  if (otherSection === ContractChangesSection.TERMINATE_CONTRACT) {
    return reason === undefined ||
      reason === TerminationDisallowedReason.NOT_CONTRACT_PARTY
      ? t('contractModification:residentChanges.pendingContractChanges')
      : undefined
  }

  const currentTenant = tenants.find(
    (tenant) => tenant.id === contract.tenant.id
  )

  return currentTenant !== undefined &&
    isAdultTenant(currentTenant) &&
    !currentTenant.isContractParty
    ? t('terminateContract:terminationDisallowedReason.pendingContractParty')
    : undefined
}
